var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    id: "svg2",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-1036.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F15C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m -22.410713,-3.3303571 a 2.3660715,2.3660715 0 1 1 -4.732143,0 2.3660715,2.3660715 0 1 1 4.732143,0 z",
    id: "path2985",
    style: {
      fill: "#F15C05",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.84528301,0,0,0.84528301,33.943395,1042.1773)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F15C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m -22.410713,-3.3303571 a 2.3660715,2.3660715 0 1 1 -4.732143,0 2.3660715,2.3660715 0 1 1 4.732143,0 z",
    id: "path2985-1",
    style: {
      fill: "#F15C05",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.84528301,0,0,0.84528301,33.943395,1052.1773)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F15C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m -22.410713,-3.3303571 a 2.3660715,2.3660715 0 1 1 -4.732143,0 2.3660715,2.3660715 0 1 1 4.732143,0 z",
    id: "path2985-1-7",
    style: {
      fill: "#F15C05",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.84528301,0,0,0.84528301,23.943395,1047.1773)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F15C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 13,3 3,8 13,13",
    id: "path3791",
    style: {
      fill: "none",
      stroke: "#F15C05",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.89fbbbc09a5abbef792b9b768ad2d7a4.svg";
export { ForwardRef as ReactComponent };